import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import {
  vFParamsPropShape,
  vFButtonSelectorOptionShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-dropdown.css';


class VFDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }


  updateValue(value) {
    const {
      updateValue: updateValueFromProps,
      form,
      field,
    } = this.props;
    const {
      setFieldValue,
      setFieldTouched,
    } = form;
    const {
      name,
    } = field;

    // overwrites the default setter using a call back in the form section (such as section 4)
    if (updateValueFromProps) {
      updateValueFromProps({
        form,
        thisField: field,
        newValue: value,
      });
      return null;
    }

    setFieldValue(name, value);
    setFieldTouched(name, true);
    return null;
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        // as we are setting this value it's seen as 'agressive' to immeditaly tell the user to fix it
        this.props.form.setFieldTouched(name, false);
      }
      return null;
    }

    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      // as we are setting this value it's seen as 'agressive' to immeditaly tell the user to fix it
      this.props.form.setFieldTouched(name, false);
    }
    return null;
  }

  render() {

    const {
      vFParams,
      field,
      form,
      displayOptions,
      readOnly,
      disabledFieldOptions,
      optional,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
      placeholder,
      optionTemplate,
      withRedux,
      getDisplayOptionsOnMount,
      getDisplayOptionsOnUpdate,
    } = vFParams;

    return (
      <VFDropdownBase
        displayOptions={displayOptions}
        readOnly={readOnly}
        updateValue={this.updateValue}
        fieldTitle={fieldTitle}
        placeholder={placeholder}
        optionTemplate={optionTemplate}
        name={name}
        value={value}
        disabled={disabled}
        inlineErrors={inlineErrors}
        touched={touched}
        optional={optional}
        withRedux={withRedux}
        getDisplayOptionsOnMount={getDisplayOptionsOnMount}
        getDisplayOptionsOnUpdate={getDisplayOptionsOnUpdate}
      />
    );
  }
}

VFDropdown.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.string),
  form: formPropShape,
  displayOptions: PropTypes.arrayOf(vFButtonSelectorOptionShape),
  disabledFieldOptions: disabledFieldOptionsShape,
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  updateValue: PropTypes.func,
};

const noValueVFDropdown = (value) => value === null;
// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_DROPDOWN = 'v-f-dropdown';

export {
  VF_DROPDOWN,
  VFDropdown,
  noValueVFDropdown,
};
